import { render, staticRenderFns } from "./ConsumeDialog.vue?vue&type=template&id=f21407f8&scoped=true"
import script from "./ConsumeDialog.vue?vue&type=script&lang=js"
export * from "./ConsumeDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsumeDialog.vue?vue&type=style&index=0&id=f21407f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21407f8",
  null
  
)

export default component.exports